<ng-container *ngIf="!!log; else emptyLog">
  <ng-container *ngFor="let key of tShirtSizeKeys">
    <div
      *ngIf="hasLog(key, log)"
      [innerHTML]="normalizeLog(key, log) | changeLogsDiffHTML : tShirtSizesLookup : (getLookup(key) | async)"
    ></div>
  </ng-container>
</ng-container>

<ng-template #emptyLog><span>&mdash;</span></ng-template>
